<template>
  <v-app>
    <!-- <v-app-bar app
               color="white">
      <div>
        <h3>{{$t('appName')}}</h3>
      </div>
      <v-spacer></v-spacer>
      <v-btn to="contact"
             text>
        <span class="mr-2">Contact us</span>
        <v-icon>mdi-email</v-icon>
      </v-btn>
    </v-app-bar> -->
    <core-app-bar />

    <core-view />

    <!-- <v-main> -->
    <!-- <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition> -->
    <!-- </v-main> -->
  </v-app>
</template>

<script>
  import CoreAppBar from "./components/core/AppBar";

  export default {
    name: "App",

    components: {
      CoreAppBar,
      CoreView: () => import("@/components/core/View"),
    },

    data: () => ({
      //
    }),
  };
</script>


<style>
  #hero h1 {
    letter-spacing: 4px !important;
  }
</style>
